import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { SsoService } from "../../../services/sso.service";
import { XsMessageBoxComponent } from "../../../../common/widgets/xs-message-box/xs-message-box.component";
import { XsSubLoginComponent } from 'src/app/core/plugins/explorer/xs-sub-login/xs-sub-login.component';

export interface LoginData {
  tipoDocumento: string;
  nroDocumento: string;
  clave: string;
  ruc: string;
}

@Component({
  selector: "app-xs-login",
  templateUrl: "./xs-login.component.html",
  styleUrls: ["./xs-login.component.css"]
})

export class XsLoginComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<XsLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public loginData: LoginData,
    public ssoService: SsoService,
    public dialog: MatDialog
  ) { }

  listaTipoDocumento = [
    { "id": "1", "nombre": "DNI" },
    { "id": "2", "nombre": "Carné de Extranjería" },
  ];

  listaRuc = [
    {
      "ruc": "201234567891",
    },
    {
      "ruc": "201234567892",
    },
    {
      "ruc": "201234567893",
    },
    {
      "ruc": "201234567894",
    },
    {
      "ruc": "201234567895",
    }
  ];

  bloquearCampo = false;
  mostrarLayoutRuc = false;

  // listaRuc = [];

  solicitud: any;
  sso: any;

  ngOnInit() {
    this.loginData.tipoDocumento = '1';
    this.fakeData();
  }

  onClickAceptar(): void {

    // MOCKUP
    // if (this.mostrarLayoutRuc) {
    //   let error = this.validarFormulario();
    //   if (!error) {
    //     console.log("mostrar explorer");
    //     this.ssoService.obtenerOpciones(this.sso).then(res => {
    //       if (res.data.estado) {
    //         console.log("STEP 03");
    //         console.log("oppp", res.data);
    //         this.dialogRef.close({ data: null, estado: "ACEPTAR" });
    //       }
    //     });
    //   }
    // } else {
    //   let error = this.validarFormulario();
    //   if (!error) {
    //     this.bloquearCampo = true;

    //     let params = {
    //       tipoDocumento: this.loginData.tipoDocumento,
    //       nroDocumento: this.loginData.nroDocumento,
    //       clave: this.loginData.clave,
    //     }
    //     this.ssoService.autenticar(params).then(res => {
    //       if (res.data.estado) {
    //         console.log("STEP 01");
    //         this.sso = res.data.sso;

    //         this.ssoService.obtenerRuc(this.sso).then(res => {
    //           if (res.data.estado) {
    //             console.log("STEP 02");
    //             this.listaRuc = res.data.listaRuc;
    //             console.log('rucs', res.data.listaRuc.length);
    //             if (res.data.listaRuc.length <= 1) {
    //               console.log("mostrar explorer");
    //               this.ssoService.obtenerOpciones(this.sso).then(res => {
    //                 if (res.data.estado) {
    //                   console.log("STEP 03");
    //                   console.log("opppin", res.data);
    //                   this.dialogRef.close({ data: null, estado: "ACEPTAR" });
    //                 }
    //               });
    //             } else if (res.data.listaRuc.length >= 2) {
    //               this.mostrarLayoutRuc = true;
    //             }
    //           }
    //         });
    //       }
    //     });
    //   }
    // }

    // FAKE
    if (this.mostrarLayoutRuc) {
      let error = this.validarFormulario();
      if (!error) {
        console.log("mostrar explorer");
        this.dialogRef.close({ data: null, estado: "ACEPTAR" });
      }
    }

    if (this.loginData.nroDocumento == '12345678') {
      this.mostrarLayoutRuc = true;
      // this.rucs();
    } else {
      console.log("mostrar explorer");
      this.dialogRef.close({ data: null, estado: "ACEPTAR" });
    }
  }

  onClickCancelar(): void {
    this.dialogRef.close({ data: null, estado: "CANCELAR" });
  }

  fakeData() {
    this.loginData.nroDocumento = '12345678';
    this.loginData.clave = '123456';
  }

  validarFormulario(): boolean {
    let mensaje = '';
    let tieneError = false;

    if (!this.loginData.nroDocumento) {
      mensaje = 'Ingrese el número de documento'
      tieneError = true;
    }

    if (!this.loginData.clave && !tieneError) {
      mensaje = 'Ingrese la contraseña'
      tieneError = true;
    }

    if (this.mostrarLayoutRuc) {
      if (!this.loginData.ruc && !tieneError) {
        mensaje = 'Seleccione un RUC'
        tieneError = true;
      }
    }

    if (tieneError) {
      this.mostrarMensajeDialog(mensaje);
    }

    return tieneError;
  }

  rucs() {
    let params = {
      opcion: "AGREGAR",
    }
    this.mostrarDialogoXsSubLogin(params);
  }

  mostrarMensajeDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }

  mostrarDialogoXsSubLogin(params) {
    const dialogRef = this.dialog.open(XsSubLoginComponent, {
      width: '350px',
      height: '100px',
      panelClass: 'xs-dlg-base',
      disableClose: true,
      data: params
    });
    console.log(params);
  }

  sAutenticar(params) {
    this.ssoService.autenticar(params).then(res => {
      if (res.data.estado) {
        //
      }
    });
  }
}
